var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader",class:{'_absolute': _vm.mode || _vm.mode > 0}},[(!_vm.mode || _vm.mode === 0)?_c('ProloaderSVG'):_c('PreloaderSVGmiddle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }